$(function($) {

    // ===================================================
    // overwrite swiper to trigger a global event on init!
    var base = window.Swiper;

    function Swiper($element, options) {
        options = options || {};
        options.init = false;
        base.call(this, $element, options);
        this.on('init',
            function() {
                site.triggerReflow();
            });
        this.init();
    }

    Swiper.prototype = Object.create(base.prototype);
    Swiper.prototype.constructor = Swiper;
    window.Swiper = Swiper;

    // ===================================================
    window.CreateSlider = function (){
        $('[slider]').each(function() {
            var $element = $(this);
            var name = $element.attr('slider');
            initSlider(name, $element);
        });
    }
    window.CreateSlider();

    function initSlider(name, $element) {
        switch (name) {
        case "acco-item":

            if ($element.find('.swiper-wrapper').children().length <= 1) {
                $element.find('.slider-arrows').remove();
                return;
                }
                if ($element[0].swiper) {
                    $element[0].swiper.destroy(true, true);
                    $element[0].swiper = null;
                }
            new Swiper($element[0],
                {
                    // for better swipe / click
                    resistance: true,
                    resistanceRatio: 0.99,

                    navigation: {
                        nextEl: $element.find('.slider-next')[0],
                        prevEl: $element.find('.slider-prev')[0],
                    },

                    pagination: {
                        el: $element.find('.swiper-pagination')[0],
                        clickable: true
                        //dynamicBullets: true,
                        //dynamicMainBullets: 10
                    },

                    loop: true,
                    autoplay: { delay: 7000 },
                    effect: 'fade',

                    init: function () {
                        $element.find('.lazyloading').removeClass('lazyloading').addClass('lazyload');
                    }

                });

                break;

            //case "room-images":
            //    $('[slider="room-images"]').each(function () {
            //    var $element = $(this);

            //    var swiper = new Swiper($element[0], {
            //        // for better swipe / click
            //        resistance: true,
            //        resistanceRatio: 0.99,

            //        loop: true,
            //        autoplay: { delay: 7000 },

            //        effect: 'fade',

            //        pagination: {
            //            el: $element.find('.swiper-pagination')[0],
            //            dynamicBullets: true,
            //        },

            //        on: {
            //            init: function () {
            //                $element.find('.lazyloading').removeClass('lazyloading').addClass('lazyload');
            //            }
            //        }
            //    });
            //});

        default:
            console.error(new Error("slider '" + name + "' not defined!"));
        }
    }


    function media(mediaBreakpoint, obj) {
        var breakpoint = window.matchMedia(mediaBreakpoint);
        var match = false;
        var check = function() {
            if (breakpoint.matches === true) {
                if (!match) {
                    obj.onMatch();
                    match = true;
                }
            } else if (breakpoint.matches === false) {
                if (match) {
                    obj.onUnmatch();
                    match = false;
                }
            }
        };
        breakpoint.addListener(check);
        check();
    }

});